import { HFlow, Modal, ModalBody, ModalFooter, Tooltip, VFlow } from 'bold-ui'
import { FooterButton } from 'components/footer-button'
import { Form, FormRenderProps } from 'components/form'
import { TitleGroup } from 'components/TitleGroup'
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import { metaPath } from 'util/metaPath'

import { calculatorFiltrosAvancados } from '../calculator-acompanhamentoCondicaoSaude'
import { IvcfFilterModel } from '../model/model-acompanhamentoCondicaoSaude'
import { validatorFiltrosAvancados } from '../validator-acompanhamentoCondicaoSaude'
import { IvcfFilterSection } from './IvcfFilterSection'

export const FILTROS_AVANCADOS_URL = '/filtros-avancados'

interface FiltrosAvancadosModalProps {
  initialValues: IvcfFilterModel
  clearModalFilterValues(): void
  applyModalFilterValues(IvcfFilterModel): void
}

const meta = metaPath<IvcfFilterModel>()

export const FiltrosAvancadosModal = (props: FiltrosAvancadosModalProps) => {
  const { initialValues, clearModalFilterValues, applyModalFilterValues } = props

  const history = useHistory()
  const match = useRouteMatch()

  const handleOnSubmit = (handleSubmit: () => void) => {
    handleSubmit()
    handleClose()
  }

  const handleOnClear = (reset: () => void) => {
    reset()
    clearModalFilterValues()
  }

  const handleClose = () => {
    history.push(match.url.replace(FILTROS_AVANCADOS_URL, ''))
  }

  const renderForm = ({
    form,
    invalid,
    values: filtrosAvancadosValues,
    handleSubmit,
  }: FormRenderProps<IvcfFilterModel>) => {
    return (
      <Modal open size='large' onClose={handleClose} closeOnBackdropClick>
        <ModalBody>
          <VFlow>
            <TitleGroup title='Filtros avançados' />
            <IvcfFilterSection meta={meta} values={filtrosAvancadosValues} onChange={form.change} />
          </VFlow>
        </ModalBody>
        <ModalFooter>
          <HFlow justifyContent='space-between'>
            <FooterButton onClick={() => handleOnClear(form.reset)}>Limpar filtros</FooterButton>
            <HFlow>
              <FooterButton onClick={handleClose}>Cancelar</FooterButton>
              <Tooltip text={invalid && 'Existem campos preenchidos de forma incorreta.'}>
                <FooterButton kind='primary' disabled={invalid} onClick={() => handleOnSubmit(handleSubmit)}>
                  Aplicar
                </FooterButton>
              </Tooltip>
            </HFlow>
          </HFlow>
        </ModalFooter>
      </Modal>
    )
  }

  return (
    <Form<IvcfFilterModel>
      render={renderForm}
      initialValues={initialValues}
      decorators={[calculatorFiltrosAvancados]}
      onSubmit={(values) => applyModalFilterValues(values)}
      validateOnBlur
      validate={validatorFiltrosAvancados}
    />
  )
}
